/*
 * @Author: dali
 * @Date: 2022-09-27 20:14:54
 * @LastEditors: dali
 * @LastEditTime: 2022-09-27 20:21:11
 * @FilePath: \gerlun-react-website\src\events\index.js
 * @Description:
 */

import { EventEmitter } from 'events'

// new一个全局的EventEmitter对象
const eventEmiter = new EventEmitter()

// 组件间通讯的事件
const eventPhone = 'prePhone'
const eventLogin = 'login'

// 注册事件监听
export function addListenerPrePhone(handler) {
  eventEmiter.on(eventPhone, handler)
}

// 触发事件
export function doPrePhone(args) {
  eventEmiter.emit(eventPhone, args)
}

// 注册登录事件监听
export function addListenerLogin(handler) {
  eventEmiter.on(eventLogin, handler)
}

// 触发登录事件
export function doLogin(args) {
  eventEmiter.emit(eventLogin, args)
}
